/* eslint-disable @typescript-eslint/camelcase */
import { Lesson, Course, Playlist } from '@fenderdigital/api-definitions/play';
import capitalize from 'lodash/capitalize'
import { Ad, AdIdentifier } from '../components/FreemiumAd/types';

export interface SegmentAdModalFields {
  ad_provider: string;
  ad_identifier: string;
  ad_displaychance: number;
  lesson_id?: string;
  lesson_name?: string;
  lesson_slug?: string;
  course_id?: string;
  course_name?: string;
  course_slug?: string;
  ad_filename: string;
}

export interface UpgradeBannerPathData {
  instrument: string;
  level?: number | null;
  path: string;
  playlist_id?: string;
  playlist?: string;
  lesson_type_1?: string;
  title?: string;
  id?: string;
  path_id?: string;
  genre?: string;
}

export type AdSegmentData = SegmentAdModalFields & Partial<UpgradeBannerPathData>;

interface AdData {
  currentCourse: Course;
  currentLesson: Lesson;
  pathData: UpgradeBannerPathData;
  currentPlaylist: Playlist;
  adFrequencyPercentage: number;
}

export const getAdSegmentData = ({
  currentCourse,
  currentLesson,
  pathData,
  currentPlaylist,
  adFrequencyPercentage,
}: AdData) => (ad: Ad, isMobile: boolean): SegmentAdModalFields => {
  const segmentParams: AdSegmentData = {
    ad_provider: 'fender_internal',
    ad_identifier: ad.adIdentifier,
    ad_displaychance: adFrequencyPercentage,
    ad_filename: isMobile
      ? `${ad.mobile}${ad.adIdentifier === AdIdentifier.MUSTANG_MICRO_BUNDLE ? '.png' : '.jpg'}`
      : `${ad.desktop}.jpg`,
  };
  if (window.location.href.includes('/course/') && currentCourse) {
    segmentParams.course_id = currentCourse.id;
    segmentParams.course_name = currentCourse.title;
    segmentParams.course_slug = currentCourse.slug;
  }
  if (currentLesson) {
    segmentParams.lesson_id = currentLesson.id;
    segmentParams.lesson_name = currentLesson.title;
    segmentParams.lesson_slug = currentLesson.slug;
    segmentParams.lesson_type_1 = currentLesson.type;
    segmentParams.level =
      currentLesson.level && +currentLesson.level > 0 ? +currentLesson.level : null;
  }

  if (pathData) {
    segmentParams.path = capitalize(pathData?.genre ?? '');
    segmentParams.path_id = pathData?.id;
    segmentParams.genre = pathData?.title?.toLowerCase();
    segmentParams.instrument = pathData?.instrument;
  }

  if (currentPlaylist) {
    segmentParams.playlist = currentPlaylist['description-long'];
    segmentParams.playlist_id = currentPlaylist.id;
  }
  return segmentParams;
};

export type CourseLessonAnalyticsData = {
  course_id: string;
  course_slug: string;
  course_title: string;
  lesson_id: string;
  lesson_slug: string;
  lesson_title: string;
};

export const courseLessonAnalyticsSelector = ({
  paths,
  courses,
}: {
  paths: any;
  courses: any;
}): CourseLessonAnalyticsData => {
  const { watching } = paths;
  const { watching: coursesWatching } = courses;
  const { currentCourse } = coursesWatching || {};
  const { currentLesson } = watching || {};
  const {
    id: course_id = undefined,
    slug: course_slug = undefined,
    title: course_title = undefined,
  } = currentCourse || {};
  const {
    id: lesson_id = undefined,
    slug: lesson_slug = undefined,
    title: lesson_title = undefined,
  } = currentLesson || {};

  return {
    course_id,
    course_slug,
    course_title,
    lesson_id,
    lesson_slug,
    lesson_title,
  };
};

export const pathAnalyticsSelector = ({
  myProgress,
  myPath,
}: {
  myProgress: any;
  myPath: any;
}): Partial<UpgradeBannerPathData> => {
  const { playlists, id, instrument, style } = myPath;
  const { level: strLevel } = myProgress;
  if (!strLevel || !playlists) return {};
  const level = Number(strLevel?.slice(-1));
  return {
    genre: style,
    level,
    instrument,
    path: capitalize(style ?? ''),
    path_id: id,
    playlist_id: playlists[level - 1]?.id,
    playlist: playlists[level - 1]?.title,
  };
};
